import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import { selectedCompanyStepAction, setBusinessDataAction } from "../../../actions/company";
import { getObjectiveAction } from "../../../actions/objective";
import { backendUrl, I_POP_OVER } from "../../../constants";
import { toggleCompanyVerificationFailed } from "../../../actions/myinfo";
import InfoModalStatic from "../../dashboard/infoModalStatic";
export default function AddObjective() {
  const dispatch = useDispatch();
  const { companyVerificationStepFailed, businessData } = useSelector((state) => state.company);

  const { objectives } = useSelector((state) => state.objective);
  const [infoModalStaicShow, setInfoModalStaticShow] = useState(false);
  const [infoModalStaicShowType, setInfoModalStaticShowType] = useState(null);

  const [expandCard, setExpandCard] = useState(false);

  const [selectCard, setSelectCard] = useState([]);

  useEffect(() => {
    dispatch(getObjectiveAction());
  }, [dispatch]);

  useEffect(() => {
    if (
      companyVerificationStepFailed &&
      companyVerificationStepFailed?.step === 4
    ) {
      handleClickInfo(I_POP_OVER.CUSTOM_API_MESSAGE);
      dispatch(selectedCompanyStepAction(4))
    }
  }, [dispatch, companyVerificationStepFailed]);

  useEffect(() => {
    const answer = businessData?.objective;
    const savedObjectiveList = answer && answer.length > 0 ? answer.map((x) => x._id || x) : [];
    setSelectCard(savedObjectiveList);
  }, [businessData]);


  const saveQuestions = async () => {
    if (selectCard.length > 0) {
      let questionsPayload = {
        ...businessData,
        objective: selectCard,
      };
      if (questionsPayload.objective.length === 1) {
        setSelectCard([]);
      }
      await dispatch(setBusinessDataAction(questionsPayload));
      dispatch(selectedCompanyStepAction(4))
    } else {
      setSelectCard([]);
    }
  };

  const handleSelectCard = (value) => {
    if (selectCard.includes(value.id)) {
      setSelectCard([]);
    } else {
      setSelectCard([value.id]);
    }
  };

  const onSubmit = async () => {
    if (selectCard.length === 1) {
      await saveQuestions();
    }
  };

  const stepBack = () => {
    dispatch(selectedCompanyStepAction(2))
  };


  const handleClickInfo = (type) => {
    setInfoModalStaticShow(true);
    setInfoModalStaticShowType(type);
  };

  return (
    <>
      <div className="row right-side-row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xl-12 objectiveUpper">
          <h5 className="edit-title">
            Step 3: Indicate your preferred objective for{" "}
            {businessData.companyName}
          </h5>
          <p className="edit-description mb-3">
            We will be sending you notifications directly to confirm and
            verify your business activities.
          </p>
        </div>
        <div
          className={`${!expandCard ? "objectiveRow pt-3" : ""
            }col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xl-12  customScrollBar`}>
          <div className="row">
            {expandCard ? (
              <div className="col-12 objectiveExpanded">
                <div
                  className="expandedObjectiveCard"
                  style={{
                    backgroundImage: `url(${backendUrl + expandCard?.image?.filename
                      })`,
                  }}>
                  <div className="expandedObjectHold">
                    <div className="expandedObjectHoldContent">
                      <button
                        type="button"
                        onClick={() => setExpandCard(false)}
                        className="objectiveClose">
                        <img src="assets/img/objectiveClose.svg" alt="" />
                      </button>
                      <p className="expandedObjectiveName">
                        {expandCard.title}
                      </p>
                      <div
                        className="objectiveDesc"
                        dangerouslySetInnerHTML={{
                          __html: expandCard.description,
                        }}></div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {objectives?.map((item, index) => (
                  <div key={index} className="col-sm-4">
                    <div
                      onClick={() => handleSelectCard(item)}
                      className={`${selectCard.includes(item.id)
                        ? "objectiveBorder"
                        : ""
                        } objectiveCard`}
                      style={{
                        backgroundImage: selectCard.includes(item.id)
                          ? "linear-gradient(0deg, var(--primary-color),var(--primary-color)), linear-gradient(0deg, var(--primary-color), var(--primary-color))"
                          : `url(${backendUrl}/${item.image.filename})`,
                      }}>
                      <div className="objectiveCardHold">
                        {selectCard.includes(item.id) && (
                          <img
                            className="selectedIcon"
                            src="assets/img/selectedCard.svg"
                            alt=""
                          />
                        )}
                        <p className="objectiveName">{item.title}</p>
                        {!selectCard.includes(item.id) && (
                          <div className="objectiveFooter">
                            {/* <img src="assets/img/infoImage.svg" alt="" /> */}
                            <i
                              onClick={(event) => {
                                event.stopPropagation();
                                setExpandCard(item);
                              }}
                              className="fa-solid fa-circle-info"></i>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xl-12 pt-3 objectiveBottom">
          {/* <p className="import-note pt-0">
                Important note:{" "}
                <span className="will-need-text">
                  We will need to contact you directly to confirm the amendment.
                </span>
              </p> */}
          <div className="modal-footer modal-bottom-action">
            <button
              type="button"
              onClick={stepBack}
              className={`btn btn-sm  mb-4 mt-3 contactus-modal-button`}
            >
              Go back
            </button>
            <button
              onClick={onSubmit}
              type="button"
              className="btn agree-button"
              disabled={selectCard?.length === 0}>
              Save and Proceed{" "}
              <img src="assets/img/nextStep.svg" alt="" />
            </button>
          </div>
        </div>
      </div>

      <InfoModalStatic
        infoModalStaticCustomMessage={
          companyVerificationStepFailed?.data || null
        }
        infoModalStaticShow={infoModalStaicShow}
        infoModalStaticClose={() => [
          setInfoModalStaticShow(false),
          dispatch(toggleCompanyVerificationFailed(null)),
        ]}
        infoModalStaicShowType={infoModalStaicShowType}
      />
    </>
  );
}
